import { FaqType } from "../Interface";

export const faqData: FaqType[]  = [
    {
      title: "How to check the scheduled interviews",
      description: "This guide demonstrates how to view the list of interviews which have been scheduled",
      fileExtension:"html"
    },
    // {
    //   title: "How to Upgrade Your QualifyMe Account Plan",
    //   description: "This guide outlines the process of upgrading your account plan on console.qualifyme.ai, starting from the home dashboard and concluding the checkout process."
    // },
    {
      title: "How to Navigate to the Account Subscription History on QualifyMe",
      description: "This guide demonstrates how to navigate from the main dashboard to the 'Account' section and then select 'Subscription History' to review plan details.",
      fileExtension:"html"
    },
    {
      title: "How to Navigate and Check Account Details on QualifyMe",
      description: "This guide details the process of navigating to the 'Account' section from the dashboard and reviewing current plan details, application limits, and job post limits.",
      fileExtension:"html"
    },
    {
      title: "How to Configure Interview Settings on QualifyMe",
      description: "This guide outlines the steps to access and configure the interview settings, including enabling interviews and saving general availability settings.",
      fileExtension:"html"
    },
    {
      title: "How to Connect Google Calendar to Interview Settings on QualifyMe",
      description: "This guide shows you how to navigate to the Interview Settings on QualifyMe and connect your Google Calendar for scheduling interviews.",
      fileExtension:"html"
    },
    {
      title: "How to Configure Organization Settings and Generate an Integration Widget",
      description: "This guide details the process of navigating to the Organization settings, switching to the Integration tab, and generating the necessary script for embedding a careers widget on a website.",
      fileExtension:"html"
    },
    {
      title: "How to Configure Website Widget Integration Settings in QualifyMe",
      description: "This guide details the process of navigating to the Organization Settings in QualifyMe, specifically focusing on configuring the widget integration by selecting a position and regenerating the necessary script code.",
      fileExtension:"html"
    },
    {
      title: "How to Customize Organization Theme Colors on QualifyMe",
      description: "This guide shows you how to navigate to the Organization Settings, select the Theme tab, and customize the color scheme by choosing a preset or setting a custom color.",
      fileExtension:"html"
    },
    {
      title: "How to Access and Update Organization Settings on QualifyMe",
      description: "This guide details the process of navigating to the Organization settings section in QualifyMe and subsequently updating the organizational details.",
      fileExtension:"html"
    },
    {
      title: "How to Update Organization Settings on QualifyMe",
      description: "This guide explains the steps to navigate to the organization settings page, select the industry, and update the organization's information on the QualifyMe console.",
      fileExtension:"html"
    },
    {
      title: "How to Configure Organization Currency Settings in QualifyMe",
      description: "This guide details the process of navigating to the organization settings and setting the preferred currency for your account on the QualifyMe console.",
      fileExtension:"html"
    },
    {
      title: "How to Configure Organization Settings in QualifyMe",
      description: "This guide outlines the process of navigating to the Organization settings and configuring basic details like the Time Zone within the QualifyMe platform.",
      fileExtension:"html"
    },
    {
      title: "How to Configure Organization Settings on QualifyMe",
      description: "This guide details the steps to navigate to the Organization settings page and update the organization details, including the domain name, currency, and support email.",
      fileExtension:"html"
    },
    {
      title: "How to Navigate and Update Organization Settings on QualifyMe",
      description: "This guide demonstrates navigating to the Organization settings section and updating the organization's details within the QualifyMe platform.",
      fileExtension:"html"
    },
    {
      title: "How to Navigate and Update Organization Settings in QualifyMe",
      description: "This guide outlines the steps to access and update the organization settings, including uploading the organization logo, within the QualifyMe platform.",
      fileExtension:"html"
    },
    {
      title: "How to Navigate to and Manage Team Members on QualifyMe",
      description: "This guide demonstrates navigating from the home dashboard to the 'Team Members' section and then toggling the status of a team member.",
      fileExtension:"html"
    },
    {
      title: "How to Invite a New Team Member in QualifyMe",
      description: "This guide details the process of navigating to the Team Members section, initiating an invitation, entering the new member's email, and successfully sending the invitation on the console.qualifyme.ai platform.",
      fileExtension:"html"
    },
    {
      title: "How to Invite a New Team Member to QualifyMe",
      description: "This guide demonstrates the process of navigating to the Team Members section, initiating an invitation, entering the new member's email, and successfully sending the invitation.",
      fileExtension:"html"
    },
    {
      title: "How to Navigate and Search for Candidates on QualifyMe AI",
      description: "This guide demonstrates navigating to the Candidates section on the QualifyMe AI console, searching for a candidate by name, and viewing the resulting list.",
      fileExtension:"html"
    },
    {
      title: "How to Upload and Process Job Application Files in QualifyMe",
      description: "This guide demonstrates navigating to the 'File Uploads' section for a specific job post and successfully uploading a resume file to be processed by the system.",
      fileExtension:"html"
    },
    {
      title: "How to Upload Resumes in Bulk for a Job Post on QualifyMe",
      description: "This guide shows the process of navigating to the Job Posts section, selecting a job, and uploading a ZIP file containing multiple resumes for bulk processing and matching.",
      fileExtension:"html"
    },
    {
      title: "How to Navigate the Candidate Dashboard and Review Application Details",
      description: "This guide details the process of navigating from the main dashboard to the Candidates section, viewing a specific candidate's job applications, and then delving into the summary of a particular application.",
      fileExtension:"html"
    },
    {
      title: "How to Review a Candidate's Job Applications and Interview Progress",
      description: "This guide shows how to navigate from the main dashboard to view and check the interview progress for a specific candidate's job application.",
      fileExtension:"html"
    },
    {
      title: "How to Navigate and View Candidate Job Applications in the Console",
      description: "This guide demonstrates navigating from the main dashboard to the Candidates section and then viewing the job applications associated with a specific candidate.",
      fileExtension:"html"
    },
    {
      title: "How to Review and Export Applications for a Full Stack Developer Clone Job Post",
      description: "This guide details the process of navigating to a specific job post, viewing the list of applicants, and accessing the option to export candidate data.",
      fileExtension:"html"
    },
    {
      title: "How to Navigate and Reject a Job Application in the Applicant Tracking System",
      description: "This guide demonstrates how to navigate from the dashboard to the job posts section, select a specific job, view a candidate's profile, and subsequently reject their application within the system.",
      fileExtension:"html"
    },
    {
      title: "How to Navigate to Job Posts and Hire a Candidate",
      description: "This guide shows the process of navigating to the 'Job Posts' section, selecting a specific job, viewing all applicants, and successfully hiring a candidate.",
      fileExtension:"html"
    },
    {
      title: "How to Navigate and Review Job Application Details in QualifyMe",
      description: "This guide details the process of navigating from the main dashboard to the Job Posts section, selecting a specific job, and then reviewing the details and interview performance of a particular candidate application.",
      fileExtension:"html"
    },
    {
      title: "How to Review Job Application Details and Profile Match Results in QualifyMe",
      description: "This guide details the process of navigating from the dashboard to view specific job posts, accessing an applicant's details, and examining their profile match results on the QualifyMe platform.",
      fileExtension:"html"
    },
    {
      title: "How to Navigate and Review a Job Application on QualifyMe",
      description: "This guide details the process of navigating from the dashboard to view the details of a specific job application, focusing on accessing candidate application information.",
      fileExtension:"html"
    },
    {
      title: "How to Navigate Job Posts and Review Shortlisted Candidates in the Job Management Dashboard",
      description: "This guide details the process of navigating from the main dashboard to the list of job posts, selecting a specific job post, and then viewing the candidates who have been shortlisted for that position.",
      fileExtension:"html"
    },
    {
      title: "How to Review Qualified Candidates for a Job Post on QualifyMe",
      description: "This guide details the process of navigating from the main dashboard to viewing and reviewing candidates who are qualified for a specific job posting.",
      fileExtension:"html"
    },
    {
      title: "How to Navigate and View Job Post Applications on QualifyMe",
      description: "This guide demonstrates navigating from the main dashboard to a specific job post's application list, detailing the steps taken to view all applicants for a selected role.",
      fileExtension:"html"
    },
    {
      title: "How to View and Edit Job Post Details on QualifyMe AI",
      description: "This guide illustrates the process of navigating from the dashboard to view and inspect the details, requirements, and interview rounds for a specific job posting, 'Mobile/App Developer (2)'.",
      fileExtension:"html"
    },
    {
      title: "How to Navigate and Edit a Job Post in QualifyMe",
      description: "This guide details the process of navigating from the main dashboard to view and edit the details of a specific job posting.",
      fileExtension:"html"
    },
    {
      title: "How to Clone a Job Post on QualifyMe",
      description: "This guide details the process of navigating to the job posts list, selecting a specific job posting, and then cloning it for reuse within the QualifyMe platform.",
      fileExtension:"html"
    },
    {
      title: "How to Navigate to the Job Posts Section and Add a New Job Post",
      description: "This guide shows you how to navigate from the home dashboard to the 'Job Posts' section and initiate adding a new job post within the console.qualifyme.ai platform.",
      fileExtension:"html"
    },
    {
      title: "How to Filter and Sort Job Posts on the Dashboard",
      description: "This guide demonstrates how to navigate to the Job Posts section, search for specific job titles, filter by status, and sort the results on the QualifyMe dashboard.",
      fileExtension:"html"
    },
    // {
    //   title: "How to Share Job Post on Whatsapp?",
    //   description: "This guide demonstrates how to locate and copy the shareable link for a job post directly from the main dashboard interface."
    // },
    {
      title: "How to Share a Job Post via Email on QualifyMe",
      description: "This guide demonstrates how to access the sharing options for a job post and select the email option on the QualifyMe platform dashboard.",
      fileExtension:"html"
    },
    {
      title: "How to Share a Job Post on LinkedIn from QualifyMe",
      description: "This guide demonstrates the process of sharing a job post link via the LinkedIn platform using the QualifyMe dashboard.",
      fileExtension:"html"
    },
    {
      title: "How to Share a Job Post on Naukri from QualifyMe",
      description: "This guide details the steps to share a job post link from the QualifyMe platform to Naukri, including copying the link and navigating to the external site.",
      fileExtension:"html"
    },
    {
      title: "How to Upgrade Your Account Plan on QualifyMe",
      description: "This guide details the process of navigating to the account section, selecting an annual subscription, and proceeding to payment for a plan upgrade.",
      fileExtension:"html"
    },
    {
      title: "How to Book a Free Support Session on QualifyMe",
      description: "This guide demonstrates the process of booking a free support session by navigating the QualifyMe dashboard, selecting a date and time on the external scheduling tool, and confirming the appointment details.",
      fileExtension:"html"
    },
    {
      title: "How to Create a New Account and Set Up Your Organization on QualifyMe",
      description: "This guide details the process of creating a new user account, signing up for the platform, setting up initial organization details, and beginning the job posting creation process on QualifyMe.",
      fileExtension:"html"
    },
    {
      title: "How to Complete the QualifyMe Sign-Up and Organization Setup Process",
      description:"This guide details the steps required to sign up for QualifyMe, enter your user details, and complete the initial organization setup. It will walk you through each stage - from creating your account to setting up your organization profile - ensuring a smooth onboarding experience.",
      fileExtension:"pdf"
    },
    {
      title: "How to Create and Configure a New Job Post",
      description:"Learn how to create and publish a new job post in QualifyMe by simply entering a prompt.",
      fileExtension:"pdf"
    },
    {
      title:"How to Complete the QualifyMe Sign-Up and Organization Setup Process",
      description:"This guide details the steps required to sign up for QualifyMe, enter your user details, and complete the initial organization setup.",
      fileExtension:"pdf"
    },
    {
      title:"How to Connect QualifyMe with Lever Hire",
      description:"This guide explains the complete setup for connecting your Lever Hire account with QualifyMe, including how to configure the integration and process candidate applications seamlessly.",
      fileExtension:"pdf"
    },    
  {
    title:"How to Process Multiple Resumes",
    description:"This guide explains how recruiters can quickly process multiple resumes in QualifyMe using the bulk upload feature.",
    fileExtension:"pdf"
  },
  {
    title:"How to Set Up Account on the QualifyMe Candidate Portal",
    description:"This guide walks candidates through setting up their QualifyMe portal. In just a few steps, candidates are ready to access the portal and begin their assessments.",
    fileExtension:"pdf"
  }
  ];
  